const formatMoney = (element) => {
  const cents = Number(element.dataset.soMoney);
  if (!Number.isFinite(cents)) return;

  const currency = element.dataset.soCurrency || 'TRY';
  const value = cents / 100;
  const hasDecimals = cents % 100 !== 0;

  if (currency === 'TRY') {
    const number = new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(value);
    element.textContent = `${number} TL`;
    return;
  }

  element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
    style: 'currency',
    currency,
  }).format(value);
};

const formatWithin = (root) => {
  if (root instanceof HTMLElement && root.matches('[data-so-money]')) formatMoney(root);
  root.querySelectorAll?.('[data-so-money]').forEach(formatMoney);
};

formatWithin(document);

new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof HTMLElement) formatWithin(node);
    }
  }
}).observe(document.body, { childList: true, subtree: true });
